import { render, staticRenderFns } from "./FabricProcessForm.vue?vue&type=template&id=2577c670&scoped=true"
import script from "./FabricProcessForm.vue?vue&type=script&lang=js"
export * from "./FabricProcessForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2577c670",
  null
  
)

export default component.exports